import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Form, Col, Row, Dropdown, Modal, Button } from "react-bootstrap";
import { RiDeleteBinLine } from "react-icons/ri";
import { useHistory } from 'react-router-dom';
import config from "../../../../config/config.json";
import { apiCall } from "../../../../_services/apiCall";
import { FaFileDownload, FaTrash, FaUpload } from "react-icons/fa";
import { IoDownloadOutline } from "react-icons/io5";

import "./Row.css";

const RowComponent = ({
  setProofDocument,
  menu,
  handleCommentChange,
  handleNoteChange,
  file,
  edit,
  assignedToDetails,
  commentModal,
  setAnswer,
  setCommentModal,
  handleProofChange,
  currentUserId,
  comment,
  rowIndex,
  fromDate,
  toDate,
  selectedSource,
  columns,
  heading,
  proofDocument,
  note,
  rowData,
  check,
  item,
  handleInputChange,
  updateMatrixData,
  updatedRows,
  radioValuee,
  emission,
  financeObject,
  emissionData,
  setEmissionData,
  handleSubmit,
  selectedSubLocationId,
  setViaEmissionData,
  documents
}) => {
  const [errors, setErrors] = useState({});
  const [docs, setDocs] = useState(proofDocument);
  const [rows, setRows] = useState(updatedRows);
  const [coll, setColl] = useState(columns);
  const [data, setData] = useState(rowData);
  const [columnsToRender, setColumnsToRender] = useState([]);
  const [fileToDelete, setFileToDelete] = useState(null);

  const [radioValue, setRadioValue] = useState(radioValuee);
  const [showData, setShowData] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [comments, setComments] = useState("");

  // const navigate = useNavigate();
  const history = useHistory();

  const handleDoubleClick = (data) => {
    if (data?.trim() !== "") {
      // Check if data is not an empty string
      setShowData(data);
      setIsModalOpen(true);
    }
  };

  useEffect(() => {
    setData(rowData);
  }, [item]);

  useEffect(() => {
    setRadioValue(radioValuee);
  }, [radioValuee]);

  useEffect(() => {
    setRows(updatedRows);
  }, [updatedRows, item]);

  useEffect(() => {
    setDocs(proofDocument);
  }, [proofDocument]);

  useEffect(() => {
    setColl(columns);
    const pageColumnType = `column${rowIndex + 1 > 0 ? rowIndex + 1 : ""}`;
    const hasOnlyGeneralColumn = columns.every(
      (col) => col.option_type.toLowerCase() === "column"
    );

    let filteredColumns;

    if (hasOnlyGeneralColumn) {
      // If columns only have "column", use all as default
      filteredColumns = columns;
    } else {
      // Otherwise, filter based on the specific column type
      filteredColumns = columns.filter((col) => {
        return col.option_type.toLowerCase() === pageColumnType.toLowerCase();
      });
    }

    // Set the filtered columns to render
    setColumnsToRender(filteredColumns);
  }, [columns, updatedRows]);

  const confirmDelete = () => {
    setProofDocument((prevState) => {
      // Clone the current proofDocument array
      const newProofDocument = [...prevState];

      // Update the specific page by filtering out the fileToDelete
      newProofDocument[rowIndex] = newProofDocument[rowIndex].filter(
        (url) => url !== fileToDelete
      );

      return newProofDocument;
    });
    setAnswer((prevState) => {
      const newProofDocument = [...prevState.proofDocument];

      newProofDocument[rowIndex] = newProofDocument[rowIndex].filter(
        (url) => url !== fileToDelete
      );

      return {
        ...prevState,
        proofDocument: newProofDocument,
      };
    });
    setShowModal(false);
    setFileToDelete(null); // Clear the file to delete
  };

  // Cancel deletion
  const cancelDelete = () => {
    setShowModal(false);
    setFileToDelete(null);
  };

  const handleComment = (e) => {
    setComments(e.target.value);
  };

  const cancelComment = () => {
    setCommentModal(false);
    setFileToDelete(null);
  };

  const getCarbonFootPrintingData = async () => {
    setEmissionData(null);
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getCarbonFootPrintingData`,
      {},
      { financialYearId: financeObject, questionId: item.questionId },
      "GET"
    );
    
    if (isSuccess && data.data) {
      // Helper function to get year and month from date string
      const getYearMonth = (dateString) => {
        const date = new Date(dateString);
        return {
          year: date.getFullYear(),
          month: date.getMonth() + 1
        };
      };

      // Find the matching entry for current row and column
      const matchingEntry = data.data.find(entry => {
        const entryFromDate = getYearMonth(entry.fromDate);
        const entryToDate = getYearMonth(entry.toDate);
        const compareFromDate = getYearMonth(fromDate);
        const compareToDate = getYearMonth(toDate);

        return entry.rowId === rowIndex && 
               entry.columnId === 0 &&
               entryFromDate.year === compareFromDate.year &&
               entryFromDate.month === compareFromDate.month &&
               entryToDate.year === compareToDate.year &&
               entryToDate.month === compareToDate.month;
      });

      if (matchingEntry) {      
        const readingValueStructure = {};
        
        // Initialize the nested structure first
        if (!readingValueStructure[matchingEntry?.rowId]) {
            readingValueStructure[matchingEntry?.rowId] = {};
        }
        
        // Now safely set the value
        readingValueStructure[matchingEntry?.rowId][matchingEntry?.columnId] = matchingEntry.readingValue;

        const emissionInfo = {
          readingValue: readingValueStructure,  // Store the properly structured reading values
          emissions: {
            co2: parseFloat(matchingEntry.co2Emissions || 0).toFixed(4),
            ch4: parseFloat(matchingEntry.ch4Emissions || 0).toFixed(4),
            n2o: parseFloat(matchingEntry.n2oEmissions || 0).toFixed(4),
            total: (
              parseFloat(matchingEntry.co2Emissions || 0) +
              parseFloat(matchingEntry.ch4Emissions || 0) +
              parseFloat(matchingEntry.n2oEmissions || 0)
            ).toFixed(4)
          },
          period: {
            from: `${getYearMonth(matchingEntry.fromDate).year}-${String(getYearMonth(matchingEntry.fromDate).month).padStart(2, '0')}`,
            to: `${getYearMonth(matchingEntry.toDate).year}-${String(getYearMonth(matchingEntry.toDate).month).padStart(2, '0')}`
          }
        };
        console.log(emissionInfo,"emissionInfo")
        setEmissionData(emissionInfo);
      }
    }
  };


  const handleChange = (colId, value) => {
    let isValid = true;
    let isTemp = true;
    let errorMessage = "";

    const col = coll[colId];
    const colOption = col.option.toLowerCase();

    // Validate email
    if (["email", "email id", "email address"].includes(colOption)) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(value)) {
        isTemp = false;
        errorMessage = "Please enter a valid email address.";
      }
    }

    // Validate number
    if (["number"].includes(colOption)) {
      const numberPattern = /^[0-9]+$/;
      if (!numberPattern.test(value)) {
        isTemp = false;
        errorMessage = "Please enter a valid number.";
      }
    }

    // Validate phone number
    if (["phone number", "phone no", "phone no."].includes(colOption)) {
      const phoneNumberPattern = /^[0-9]{10}$/;
      if (!phoneNumberPattern.test(value)) {
        isTemp = false;
        errorMessage = "Please enter a valid 10-digit phone number.";
      }
    }

    // Update errors state
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${rowIndex}-${colId}`]: isTemp ? "" : errorMessage,
    }));

    if (isValid) {
      if (typeof item.emissionMapping === "string") {
        const parsedEmissionMapping = JSON.parse(item.emissionMapping);
        if (parsedEmissionMapping[rowIndex] && parsedEmissionMapping[rowIndex][colId]) {
          setViaEmissionData(true);
          // Store the data in sessionStorage
          const navigationData = {
            emissionMapping: parsedEmissionMapping[rowIndex][colId],
            fromDate,
            toDate,
            selectedSource,
            questionId:item.questionId,
            rowIndex:rowIndex,
            colId:colId,
            selectedSubLocationId:selectedSubLocationId
          };
          sessionStorage.setItem('scope1NavigationData', JSON.stringify(navigationData));
          handleSubmit();
          // Navigate to the route without query parameters
          const baseURL = config.baseURL;

          window.location.href = `${baseURL}/#/carbon-footprinting/scope-1`;
        }
      }
      // Update rowData state for the specific column
      handleInputChange(rowIndex, colId, value);

      // Update matrixData with the new rowData
      updateMatrixData(rowIndex, colId, value);
    }
  };

  const handleFileDownload = (url) => {
    const replacedUrl = url.replace(
      "https://riu-bucket.s3.ap-south-1.amazonaws.com",
      "https://copyadatafromawstoazure.blob.core.windows.net/uploads"
    );
    const link = document.createElement("a");
    link.href = replacedUrl;
    link.target = "_blank"; // Opens in a new tab
    link.download = replacedUrl.split("/").pop();
    document.body.appendChild(link); // Append to body
    link.click();
    document.body.removeChild(link); // Clean up
  };

  const handleDeleteClick = (url) => {
    setFileToDelete(url);
    setShowModal(true);
  };

  // Handle percentage input change
  const handlePercentageChange = (colId, value) => {
    let finalValue = value;

    // Allow "NIL" as a valid input
    if (value !== "NIL") {
      // Check if "N", "NI", or "NIL" is being typed and allow it
      if (value === "N" || value === "NI" || value === "NIL") {
        finalValue = value;
      } else {
        // Remove non-numeric characters except for a single decimal point
        const sanitizedValue = value.replace(/[^\d.]/g, "");

        // Ensure there's only one decimal point
        finalValue =
          sanitizedValue.split(".").length > 2
            ? sanitizedValue.split(".").slice(0, 2).join("")
            : sanitizedValue;
      }
    }

    handleChange(colId, finalValue);
  };

  const saveComment = () => {
    // Save the comment and close the modal
    handleCommentChange(comments);

    setCommentModal(false);
  };

  const handleRadioChange = (value, colId, otherColId) => {
    setRadioValue(value);
    handleChange(colId, value);
    handleChange(otherColId, ""); // Set the other option to an empty string
  };

  useEffect(() => {
    setData(rowData);
  }, [rowData]);

  useEffect(() => {
    if(item.emissionMapping){
      getCarbonFootPrintingData();
    }
  }, [item.emissionMapping,rowIndex,fromDate,selectedSource]);

  const itemHeight = "6vh";
  const inputStyle = {
    height: itemHeight,
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid #ccc",

    backgroundColor: "white",
    borderRadius: "5px",
  };
  const filteredDocs = docs;

  // const filteredComments = Array.isArray(comment)
  //   ? comment.filter(
  //       (c, index) =>
  //         index < filteredDocs.length && (typeof c === "string" || c === "")
  //     )
  //   : [];

  const filteredComments = (comment || []).filter(
    (commen) => commen && typeof commen === "string" && commen.trim() !== ""
  );

  return (
    <>
      <Row>
        {heading && heading?.length ? (
          <Col md={12}>
            <Form.Group controlId={`formInput-${rowIndex}-entity`}>
              <Form.Label className="custom-label">Question</Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#Dfebef",
                  lineHeight: "1",
                  minHeight: "40px", // Set a minimum height (adjust as necessary)
                  overflowY: "auto", // Allow vertical scroll if content exceeds maxHeight
                  resize: "vertical", // Prevent resizing, or use "vertical" to allow only vertical resizing
                }}
                type="textarea"
                value={heading[0]?.option || ""}
                onDoubleClick={() => handleDoubleClick(heading[0]?.option)}
                readOnly
              />
            </Form.Group>
          </Col>
        ) : (
          <></>
        )}
      </Row>
      <Row>
        {data && data?.option !== "1" && data?.option !== "one" ? (
          <Col md={12}>
            <Form.Group controlId={`formInput-${rowIndex}-entity`}>
              <Form.Label className="custom-label">Attribute</Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#Dfebef",
                  lineHeight: "1",
                  minHeight: "40px", // Set a minimum height (adjust as necessary)
                  overflowY: "auto", // Allow vertical scroll if content exceeds maxHeight
                  resize: "vertical", // Prevent resizing, or use "vertical" to allow only vertical resizing
                }}
                as="textarea"
                type="text"
                value={data?.option || ""}
                onDoubleClick={() => handleDoubleClick(data?.option)}
                readOnly
              />
            </Form.Group>
          </Col>
        ) : (
          <></>
        )}
      </Row>
      <Row>
        {columnsToRender?.map((col, index) => {
          const colOptionLower = col.option.toLowerCase(); // Convert to lowercase for a case-insensitive match
          const isEmail = ["email", "email id", "email address"].includes(
            colOptionLower
          );
          // const isNumber = ["number", "phone number", "phone no"].includes(
          //   colOptionLower
          // );
          const isYesOrNo =
            colOptionLower.includes("(yes/no)") ||
            data?.option.includes("Yes/No");
          const isPercentage =
            colOptionLower.includes("%age") ||
            colOptionLower.includes("%") ||
            colOptionLower.includes("percentage");

          const isRadioOption1 =
            col.option ===
            "Disclosures under this report made on a standalone basis (i.e. only for the entity).";
          const isRadioOption2 =
            col.option ===
            "On a consolidated basis (i.e. for the entity & all the entities which form a part of its consolidated financial statements, taken together)";

          if (isRadioOption1 || isRadioOption2) {
            return (
              <Col key={col.detail_id} md={12}>
                <Form.Group
                  controlId={`formInput-${rowIndex}-${col.detail_id}`}
                >
                  <Form.Check
                    type="radio"
                    id={`radio-${rowIndex}-${index}`}
                    name={`radio-${rowIndex}`}
                    label={
                      <span
                        className="custom-radio-label"
                        style={{
                          color: "rgba(0,0,0,0.70)",
                          fontSize: "12px",
                          fontFamily: "Open Sans",
                          fontWeight: 400,
                          wordWrap: "break-word",
                        }}
                      >
                        {col.option}
                      </span>
                    }
                    checked={radioValue === col.option}
                    onChange={() =>
                      handleRadioChange(
                        col.option,
                        index,
                        isRadioOption1 ? index + 1 : index - 1
                      )
                    }
                    readOnly={
                      menu === "audit" ||
                      (assignedToDetails?.assignedTo?.length > 0 &&
                        !assignedToDetails?.assignedTo?.some(
                          (id) => parseInt(id, 10) === currentUserId
                        )) ||
                      (check && edit) ||
                      (assignedToDetails?.dueDate &&
                        new Date(assignedToDetails.dueDate).setHours(
                          0,
                          0,
                          0,
                          0
                        ) < new Date().setHours(0, 0, 0, 0))
                    }
                  />
                </Form.Group>
              </Col>
            );
          }

          return (
            <Col
              key={col.detail_id}
              md={
                // isYesOrNo ? 3 :
                col.option.replace(/\(Yes\/No\)/g, "").length > 200 ? 12 : 6
                // mdValue
              }
            >
              <Form.Group controlId={`formInput-${rowIndex}-${col.detail_id}`}>
                <Form.Label className="custom-label">
                  {col.option.replace(/\(Yes\/No\)/g, "")}
                </Form.Label>

                {isYesOrNo ? (
                  <div className="select-wrapper">
                    <Dropdown
                      onSelect={(eventKey) => handleChange(index, eventKey)}
                      placeholder="Select Yes/No"
                    >
                      <Dropdown.Toggle
                        id="dropdown-basic"
                        style={{
                          backgroundColor: "#Dfebef",
                          color: "black",
                          borderColor: "white",
                          width: "100%",
                        }}
                        // readOnly={
                        //   menu === "audit" ||
                        //   (assignedToDetails?.assignedTo?.length > 0 &&
                        //     parseInt(assignedToDetails.assignedTo[0], 10) !==
                        //       currentUserId)
                        // }
                        readOnly={
                          menu === "audit" ||
                          (assignedToDetails?.assignedTo?.length > 0 &&
                            !assignedToDetails?.assignedTo?.some(
                              (id) => parseInt(id, 10) === currentUserId
                            )) ||
                          (check && edit) ||
                          (assignedToDetails?.dueDate &&
                            new Date(assignedToDetails.dueDate).setHours(
                              0,
                              0,
                              0,
                              0
                            ) < new Date().setHours(0, 0, 0, 0))
                        }
                      >
                        <span style={{ marginRight: "85%" }}>
                          {rows?.[rowIndex]?.[index] ?? "Select "}
                        </span>
                      </Dropdown.Toggle>
                      {!(
                        menu === "audit" ||
                        (assignedToDetails?.assignedTo?.length > 0 &&
                          !assignedToDetails?.assignedTo?.some(
                            (id) => parseInt(id, 10) === currentUserId
                          )) ||
                        (check && edit) ||
                        (assignedToDetails?.dueDate &&
                          new Date(assignedToDetails.dueDate).setHours(
                            0,
                            0,
                            0,
                            0
                          ) < new Date().setHours(0, 0, 0, 0))
                      ) && (
                        <Dropdown.Menu>
                          <Dropdown.Item eventKey="Yes">Yes</Dropdown.Item>
                          <Dropdown.Item eventKey="No">No</Dropdown.Item>
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  </div>
                ) : isPercentage ? (
                  <div className="input-percentage-wrapper">
                    <Form.Control
                      style={{
                        backgroundColor: "#Dfebef",
                        lineHeight: "1",
                        minHeight: "40px", // Set a minimum height (adjust as necessary)
                        overflowY: "auto", // Allow vertical scroll if content exceeds maxHeight
                        resize: "vertical", // Prevent resizing, or use "vertical" to allow only vertical resizing
                      }}
                      type="text"
                      as="textarea"
                      value={rows?.[rowIndex]?.[index] ?? ""}
                      onChange={(e) =>
                        handlePercentageChange(index, e.target.value)
                      }
                      // readOnly={
                      //   menu === "audit" ||
                      //   (assignedToDetails?.assignedTo?.length > 0 &&
                      //     parseInt(assignedToDetails.assignedTo[0], 10) !==
                      //       currentUserId)
                      // }
                      readOnly={
                        menu === "audit" ||
                        (assignedToDetails?.assignedTo?.length > 0 &&
                          !assignedToDetails?.assignedTo?.some(
                            (id) => parseInt(id, 10) === currentUserId
                          )) ||
                        (check && edit) ||
                        (assignedToDetails?.dueDate &&
                          new Date(assignedToDetails.dueDate).setHours(
                            0,
                            0,
                            0,
                            0
                          ) < new Date().setHours(0, 0, 0, 0))
                      }
                    />
                    <span className="percentage-sign">%</span>
                  </div>
                ) : (
                  <>
                    <Form.Control
                      style={{
                        backgroundColor: "#Dfebef",
                        height: "auto", // Auto height based on content

                        lineHeight: "1",
                        minHeight: "40px", // Set a minimum height (adjust as necessary)
                        overflowY: "auto", // Allow vertical scroll if content exceeds maxHeight
                        resize: "vertical", // Prevent resizing, or use "vertical" to allow only vertical resizing
                      }}
                      type={isEmail ? "email" : "text"}
                      as="textarea"
                      // type={isEmail ? "email" : isNumber ? "tel" : "text"}
                      value={rows?.[rowIndex]?.[index] || emissionData?.readingValue?.[rowIndex]?.[index] || ""}
                      onDoubleClick={() =>
                        handleDoubleClick(rows?.[rowIndex]?.[index])
                      }
                      onChange={(e) => handleChange(index, e.target.value)}
                      placeholder=" "
                      // readOnly={
                      //   menu === "audit" ||
                      //   (assignedToDetails?.assignedTo?.length > 0 &&
                      //     parseInt(assignedToDetails.assignedTo[0], 10) !==
                      //       currentUserId)
                      // }
                      readOnly={
                        menu === "audit" ||
                        (assignedToDetails?.assignedTo?.length > 0 &&
                          !assignedToDetails?.assignedTo?.some(
                            (id) => parseInt(id, 10) === currentUserId
                          )) ||
                        (check && edit) ||
                        (assignedToDetails?.dueDate &&
                          new Date(assignedToDetails.dueDate).setHours(
                            0,
                            0,
                            0,
                            0
                          ) < new Date().setHours(0, 0, 0, 0))
                      }
                    />
                    {errors[`${rowIndex}-${index}`] && (
                      <Form.Text className="text-danger">
                        {errors[`${rowIndex}-${index}`]}
                      </Form.Text>
                    )}
                  </>
                )}
              </Form.Group>
            </Col>
          );
        })}
        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Data</Modal.Title>
          </Modal.Header>
          <Modal.Body>{showData}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setIsModalOpen(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Row>

      {emission &&
      item &&
      (item?.questionId === 451 || item?.questionId === 452) ? (
        emission[rowIndex] && emission[rowIndex].length === 2 ? (
          <Row>
            <Col md={6}>
              <Form.Group controlId={`formInput-${rowIndex}-male`}>
                <Form.Label className="custom-label">Energy</Form.Label>
                <Form.Control
                  style={{
                    backgroundColor: "#Dfebef",
                    lineHeight: "1",
                    minHeight: "40px",
                    overflowY: "auto",
                    resize: "vertical",
                  }}
                  as="textarea"
                  type="text"
                  value={emission[rowIndex][0] + " GJ"}
                  readOnly
                />
              </Form.Group>
            </Col>
            {item?.questionId === 452 ? (
              <Col md={6}>
                <Form.Group controlId={`formInput-${rowIndex}-female`}>
                  <Form.Label className="custom-label">Emission</Form.Label>
                  <Form.Control
                    style={{
                      backgroundColor: "#Dfebef",
                      lineHeight: "1",
                      minHeight: "40px",
                      overflowY: "auto",
                      resize: "vertical",
                    }}
                    as="textarea"
                    type="text"
                    value={emission[rowIndex][1] + " tCO2"}
                    readOnly
                  />
                </Form.Group>
              </Col>
            ) : (
              <></>
            )}
          </Row>
        ) : null
      ) : null}

      {(item && item?.questionId == 46) || (item && item?.questionId == 48) ? (
        <Row>
          <Col md={6}>
            <Form.Group controlId={`formInput-${rowIndex}-male`}>
              <Form.Label className="custom-label">
                Male Trigger Value
              </Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#Dfebef",
                  lineHeight: "1",
                  minHeight: "40px",
                  overflowY: "auto",
                  resize: "vertical",
                }}
                as="textarea"
                type="text"
                value={"12%"}
                readOnly
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group controlId={`formInput-${rowIndex}-female`}>
              <Form.Label className="custom-label">
                Female Trigger Value
              </Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#Dfebef",
                  lineHeight: "1",
                  minHeight: "40px",
                  overflowY: "auto",
                  resize: "vertical",
                }}
                as="textarea"
                type="text"
                value={"12%"}
                readOnly
              />
            </Form.Group>
          </Col>
        </Row>
      ) : (
        <></>
      )}

      {item?.applicableNote === 1 && (
        <Row>
          <Col md={12}>
            <Form.Group controlId="formInput12">
              <Form.Label className="custom-label">Note</Form.Label>
              <Form.Control
                style={{
                  backgroundColor: "#Dfebef",
                  lineHeight: "1",
                  minHeight: "40px", // Set a minimum height (adjust as necessary)
                  overflowY: "auto", // Allow vertical scroll if content exceeds maxHeight
                  resize: "vertical", // Prevent resizing, or use "vertical" to allow only vertical resizing
                }}
                type="text"
                as="textarea"
                // value={note ? note : ""}
                value={note && !/^(\s*,\s*)+$/.test(note) ? note : ""}
                onDoubleClick={() => handleDoubleClick(note)}
                onChange={handleNoteChange}
                readOnly={
                  menu === "audit" ||
                  (assignedToDetails?.assignedTo?.length > 0 &&
                    !assignedToDetails?.assignedTo?.some(
                      (id) => parseInt(id, 10) === currentUserId
                    )) ||
                  (check && edit) ||
                  (assignedToDetails?.dueDate &&
                    new Date(assignedToDetails.dueDate).setHours(0, 0, 0, 0) <
                      new Date().setHours(0, 0, 0, 0))
                }
              />
            </Form.Group>
          </Col>
        </Row>
      )}
       {emissionData && (
        <div className="emission-data-display p-3 mt-3" style={{
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>

          <div className="emissions-details mt-3">
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">CO₂ Emissions:</span>
              <span className="fw-semibold">{emissionData.emissions.co2}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">CH₄ Emissions:</span>
              <span className="fw-semibold">{emissionData.emissions.ch4}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">N₂O Emissions:</span>
              <span className="fw-semibold">{emissionData.emissions.n2o}</span>
            </div>
            <div className="d-flex justify-content-between pt-2 border-top mt-2">
              <span className="text-muted fw-semibold">Total Emissions:</span>
              <span className="fw-bold text-primary">{emissionData.emissions.total}</span>
            </div>
          </div>
        </div>
      )}
      <Form.Group>
        <Col md={12}>
          {menu !== "audit" && (
            <Form.Group
              controlId="formFile"
              className="custom-file-upload"
              style={{ marginBottom: "5%" }}
            >
              <Form.Label className="custom-label">
                Upload Attachment
              </Form.Label>
              <div className="file-upload-wrapper">
                <Link
                  to="/upload-document"
                  className="upload-btn flex items-center gap-2"
                  style={{ textDecoration: "none" }}
                >
                  <div style={{ height: "12px", width: "12px" }}>
                    <FaUpload height={"12px"} width={"12px"} />
                  </div>
                  <span>Upload a file</span>
                </Link>
              </div>
              {/* <div className="file-upload-wrapper">
                <label className="upload-btn">
                  <div style={{ height: "12px", width: "12px" }}>
                    <FaUpload height={"12px"} width={"12px"} />
                  </div>
                  <span>Upload a file</span>
                  <Form.Control
                    type="file"
                    disabled={
                      menu === "audit" ||
                      (assignedToDetails?.assignedTo?.length > 0 &&
                        !assignedToDetails?.assignedTo?.some(
                          (id) => parseInt(id, 10) === currentUserId
                        )) ||
                      (check && edit) ||
                      (assignedToDetails?.dueDate &&
                        new Date(assignedToDetails.dueDate).setHours(
                          0,
                          0,
                          0,
                          0
                        ) < new Date().setHours(0, 0, 0, 0))
                    }
                    style={{ display: "none" }} // Hide the default file input
                    onChange={(e) => handleProofChange(e)}
                  />
                </label>
              </div> */}
            </Form.Group>
          )}
        </Col>

        {filteredDocs && Object.keys(filteredDocs)?.length > 0 && (
          <div
            style={{
              backgroundColor: "#DFEBEF",
              width: "100%",
              padding: "20px",
              borderRadius: "8px",
              marginLeft: "0px",
              marginTop: menu !== "audit" ? "0%" : "3%",
            }}
          >
            <Row>
              {filteredDocs &&
                Object.keys(filteredDocs)?.length > 0 &&
                Object.entries(filteredDocs || {}).map(([id, docMeta], docIndex) => {
                  const documentMeta = documents[id]?.fileMetadata;
                  const url = documentMeta?.url || '';
                  const docFileName = documentMeta?.fileName || '';

                  return (
                    <Col key={docIndex} md={4} style={{ marginBottom: "15px" }}>
                      <div style={inputStyle}>
                        <span
                          style={{
                            marginLeft: 10,
                            marginRight: 10,
                            flexGrow: 1,
                            fontSize: "12px",
                            maxWidth: "70%",
                          }}
                          title={docFileName}
                        >
                          {(docFileName || "")}
                        </span>

                        <IoDownloadOutline
                          style={{
                            marginLeft: 10,
                            cursor: "pointer",
                            height: "20px",
                            width: "20px",
                            color: "black",
                          }}
                          onClick={() => handleFileDownload(url)}
                          title="Download File"
                        />

                        {!(
                          menu === "audit" ||
                          (assignedToDetails?.assignedTo?.length > 0 &&
                            !assignedToDetails?.assignedTo?.some(
                              (assignedId) => parseInt(assignedId, 10) === currentUserId
                            ))
                        ) && (
                          <RiDeleteBinLine
                            style={{
                              cursor: "pointer",
                              height: "20px",
                              width: "20px",
                              color: "black",
                              marginLeft: "1rem",
                            }}
                            onClick={() => handleDeleteClick(id)}
                            title="Remove File"
                          />
                        )}
                      </div>
                    </Col>
                  );
                })
              }
            </Row>
          </div>
        )}
      </Form.Group>
      <Modal show={showModal} onHide={cancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to delete this file?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={commentModal} onHide={cancelComment} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Add a comment for file</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="formComment">
            <div>{file}</div>
            <Form.Label>Please provide a comment (optional):</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={comments}
              onChange={(e) => handleComment(e)}
              placeholder="Enter your comment here"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={cancelDelete}>
            Cancel
          </Button>
          <Button variant="primary" onClick={saveComment}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>     
    </>
  );
};

export default RowComponent;
